<form novalidate #motorsAuctionPricingSectionForm="ngForm">
    <tg-row *ngIf="draftLoaded$ | async" class="motors-listing-details-page__section">
        <tg-col sm="12" lg="8">
            <tg-row>
                <tg-col lg="6">
                    <tg-select-container label="Auction type">
                        <select tgSelect name="auctionType" required (change)="updateAuctionType()"
                        [disabled]="isEditPage"
                            [(ngModel)]="draftData.listingDetails.auctionType" [validation]="
                                validation.listingDetails.auctionType
                                    | toValidator
                            ">
                            <option [ngValue]="AuctionTypeEnum.auctionAndBuyNow">Auction & Buy Now</option>
                            <option [ngValue]="AuctionTypeEnum.buyNowOnly">Buy Now only</option>
                        </select>
                    </tg-select-container>
                </tg-col>
            </tg-row>

            <div *ngIf="draftData.listingDetails.auctionType === AuctionTypeEnum.auctionAndBuyNow">
                <tg-row>
                    <tg-col lg="6">
                        <tg-input-container label="Start price"
                            description="Set lower than reserve to attract more bids">
                            <span class="
                                motors-auction-pricing__section__currency-symbol
                            ">$</span>
                            <input tgTextInput wholeNumber name="startPrice" (blur)="publish()" [(ngModel)]="
                                    draftData.listingDetails.startPrice
                                " [validation]="
                                    validation.listingDetails.startPrice
                                        | toValidator
                                "
                                [disabled]="isDisableStartPriceInput" />
                        </tg-input-container>
                    </tg-col>
                    <tg-col lg="6">
                        <tg-input-container label="Reserve price"
                            description="The lowest price you're willing to sell for">
                            <span class="
                                motors-auction-pricing__section__currency-symbol
                            ">$</span>
                            <input tgTextInput wholeNumber name="reservePrice" (blur)="publish()" [(ngModel)]="
                                    draftData.listingDetails.reservePrice
                                " [validation]="reservePriceValidation()"
                                [disabled]="isDisableReservePriceInput" />
                        </tg-input-container>
                    </tg-col>
                </tg-row>

                <tg-row *ngIf="feeCalculationFacade.isIncreasePricingTier$ | async">
                    <tg-col md="8" sm="12">
                        <tg-info-box>
                            Your listing fee will be updated according to the new listing price
                        </tg-info-box>
                    </tg-col>
                </tg-row>

                <tg-row>
                    <tg-col lg="6">
                        <tg-input-container label="Buy Now price"
                            description="The price you'd sell your vehicle for now">
                            <span class="
                                motors-auction-pricing__section__currency-symbol
                            ">$</span>
                            <input tgTextInput wholeNumber name="buyNowPrice" (blur)="publish()" [(ngModel)]="
                                    draftData.listingDetails.buyNowPrice
                                " [validation]="buynowPriceValidation()"
                                [disabled]="isDisableBuyNowPriceInput" />
                        </tg-input-container>
                    </tg-col>
                </tg-row>
            </div>

            <div *ngIf="draftData.listingDetails.auctionType === AuctionTypeEnum.buyNowOnly">
                <tg-row>
                    <tg-col lg="6">
                        <tg-input-container label="Buy Now price"
                            description="The price you'd sell your vehicle for now">
                            <span class="
                                motors-auction-pricing__section__currency-symbol
                            ">$</span>
                            <input tgTextInput wholeNumber name="buyNowPrice" (blur)="publish()" [(ngModel)]="
                                    draftData.listingDetails.buyNowPrice
                                " [validation]="
                                    validation.listingDetails.buyNowPrice
                                        | toValidator
                                "
                                 [disabled]="isEditPage"/>
                        </tg-input-container>
                    </tg-col>
                </tg-row>
                <tg-row *ngIf="feeCalculationFacade.isIncreasePricingTier$ | async">
                    <tg-col md="8" sm="12">
                        <tg-info-box>
                            Your listing fee will be updated according to the new listing price
                        </tg-info-box>
                    </tg-col>
                </tg-row>
            </div>

            <tg-row class="motors-auction-pricing__section__authenticated-only">
                <tg-col>
                    <tg-checkbox name="authenticatedUsersOnlyCheckbox" [(ngModel)]="
                            draftData.listingDetails
                                .allowBidsFromAuthenticatedUsersOnly
                        " (change)="publish()"
                        class="motors-auction-pricing__section__auth-users-checkbox--no-padding-left"
                        [disabled] = "isDisableAllowBidsFromAuthenticatedUsersOnly">
                        <tg-label class="motors-auction-pricing__section__auth-users-checkbox--no-bold">Allow bids from
                            <a href="https://help.trademe.co.nz/hc/en-us/articles/360007263251?popup=true"
                                target="_blank">authenticated</a>
                            users only
                        </tg-label>
                    </tg-checkbox>
                </tg-col>
            </tg-row>
        </tg-col>
    </tg-row>
</form>
